<div class="w-100">
  <div class="col-lg-3 col-12 mx-auto my-4 p-4">
    <div
      class="
        position-relative
        ratio
        ratio-4x3
        col-8
        mx-auto
      "
    >
      <img
        ngSrc="/assets/images/no-data.webp"
        fill
        priority
        class="object-fit-contain"
        alt="No data"
      />
    </div>

    <div
      class="
        text-center
        mt-lg-8
        mt-4
        fw-bold
      "
    >
      {{ 'NoDataTable' | translate }}
    </div>
  </div>
</div>
